export default __webpack_public_path__ + "static/media/Zombaze Portfolio Image.da345bdc.png";